import React from 'react';
import { Link } from 'react-router-dom';
import { Building2, Mail, Phone, MapPin, Facebook, Twitter, Instagram, Linkedin } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-gray-900 text-gray-300" data-testid="footer">
      <div className="max-w-7xl mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-8">
          {/* Company Info */}
          <div>
            <div className="mb-6">
              <img 
                src="/logo.png" 
                alt="Sanchez BnB Prestige LLC" 
                className="h-32 w-auto md:h-40 lg:h-48"
              />
            </div>
            <p className="text-sm mb-2 font-semibold text-white">
              Luxury Short-Term Stays
            </p>
            <p className="text-sm mb-4">
              Serving Sacramento, Los Angeles, San Bernardino County & Arizona
            </p>
            <div className="flex gap-3">
              <a href="#" className="bg-gray-800 hover:bg-blue-600 p-2 rounded-lg transition-colors" data-testid="social-facebook">
                <Facebook className="h-5 w-5" />
              </a>
              <a href="#" className="bg-gray-800 hover:bg-blue-600 p-2 rounded-lg transition-colors" data-testid="social-twitter">
                <Twitter className="h-5 w-5" />
              </a>
              <a href="#" className="bg-gray-800 hover:bg-blue-600 p-2 rounded-lg transition-colors" data-testid="social-instagram">
                <Instagram className="h-5 w-5" />
              </a>
              <a href="#" className="bg-gray-800 hover:bg-blue-600 p-2 rounded-lg transition-colors" data-testid="social-linkedin">
                <Linkedin className="h-5 w-5" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-white font-bold mb-4">Quick Links</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="hover:text-blue-400 transition-colors" data-testid="footer-home">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/properties" className="hover:text-blue-400 transition-colors" data-testid="footer-properties">
                  Properties
                </Link>
              </li>
              <li>
                <Link to="/about" className="hover:text-blue-400 transition-colors" data-testid="footer-about">
                  About Us
                </Link>
              </li>
              <li>
                <Link to="/contact" className="hover:text-blue-400 transition-colors" data-testid="footer-contact">
                  Contact
                </Link>
              </li>
            </ul>
          </div>

          {/* Our Locations */}
          <div>
            <h3 className="text-white font-bold mb-4">Our Locations</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/properties?city=Sacramento" className="hover:text-blue-400 transition-colors">
                  Sacramento, CA
                </Link>
              </li>
              <li>
                <Link to="/properties?city=Los Angeles" className="hover:text-blue-400 transition-colors">
                  Los Angeles, CA
                </Link>
              </li>
              <li>
                <Link to="/properties?city=San Bernardino" className="hover:text-blue-400 transition-colors">
                  San Bernardino County, CA
                </Link>
              </li>
              <li>
                <Link to="/properties?state=Arizona" className="hover:text-blue-400 transition-colors">
                  Arizona
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 className="text-white font-bold mb-4">Contact Us</h3>
            <ul className="space-y-3">
              <li className="flex items-start gap-2">
                <MapPin className="h-5 w-5 flex-shrink-0 mt-0.5" />
                <span className="text-sm">1401 21st St., Suite R<br />Sacramento, CA 95811-5226</span>
              </li>
              <li>
                <a href="tel:+18006519198" className="flex items-center gap-2 hover:text-blue-400 transition-colors" data-testid="footer-phone">
                  <Phone className="h-5 w-5" />
                  <span className="text-sm">800-651-9198</span>
                </a>
              </li>
              <li>
                <a href="mailto:info@sanchezbnbprestigenet.com" className="flex items-center gap-2 hover:text-blue-400 transition-colors" data-testid="footer-email">
                  <Mail className="h-5 w-5" />
                  <span className="text-sm">info@sanchezbnbprestigenet.com</span>
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-800 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-sm">
              © {new Date().getFullYear()} SanchezbnbprestigeLLC. All rights reserved.
            </p>
            <div className="flex gap-6 text-sm">
              <a href="#" className="hover:text-blue-400 transition-colors">
                Privacy Policy
              </a>
              <a href="#" className="hover:text-blue-400 transition-colors">
                Terms of Service
              </a>
              <a href="#" className="hover:text-blue-400 transition-colors">
                Cookie Policy
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;